import { render, staticRenderFns } from "./ServicesGallery.vue?vue&type=template&id=8e3579c0&scoped=true&"
import script from "./ServicesGallery.vue?vue&type=script&lang=js&"
export * from "./ServicesGallery.vue?vue&type=script&lang=js&"
import style0 from "./ServicesGallery.vue?vue&type=style&index=0&id=8e3579c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3579c0",
  null
  
)

export default component.exports